import Button from "@edaz/edazkit/Button/index";
import { IconType } from "@edaz/edazkit/Icon";
import React from "react";
import type { IWithPrevNextNavigationViewModel } from "viewModels/types";

export interface NavigationFooterProps {
  vm: IWithPrevNextNavigationViewModel;
}

export function NavigationFooter(props: NavigationFooterProps) {
  const { vm } = props;

  return (
    <div className="d-flex justify-content-between w-100 mb-n5">
      <Button
        disabled={!vm.hasPrevious || vm.isBusy}
        onClick={vm.onPreviousClick}
        iconLeft={IconType.ArrowLeft}
        variant="light"
        className="mr-3"
      />
      <Button
        disabled={!vm.hasNext || vm.isBusy}
        onClick={vm.onNextClick}
        iconLeft={IconType.ArrowRight}
        variant="light"
        className="ml-3"
      />
    </div>
  );
}
